import React from "react";

import clsx from "clsx";
import { get } from "lodash";

import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { descriptorToPath } from "@north-beam/nb-client-side";
import { jsonHash } from "@north-beam/nb-common";
import { AdIcon } from "@pages/objects/utils";

import { type ColumnDef } from "../table-utils";

export const DimensionDataFormatter = ({
  row,
  column,
}: DataTypeProvider.ValueFormatterProps) => {
  const columnOptions = (column as ColumnDef)?.options;

  const isPlatformView = columnOptions?.isPlatformView;
  const path = descriptorToPath(row.key);
  let isBreakdown = false;
  let isAd = false;
  try {
    const adObject = JSON.parse(path[path.length - 1]);
    isAd = get(adObject, ["nbt", "ad"]) !== undefined;

    if (typeof adObject !== "object") {
      isBreakdown = true;
    }
  } catch (e) {
    // Breakdowns are strings and non JSON serializable
    isBreakdown = true;
  }

  const isLinkable = isPlatformView || (!isBreakdown && !isAd);

  return (
    <>
      <div
        className={clsx(
          "overflow-hidden font-semibold text-ellipsis",
          (isLinkable || isBreakdown) && "cursor-pointer",
        )}
        onClick={() => {
          const selectionLength = window.getSelection()?.toString().length ?? 0;
          if (selectionLength <= 0) {
            if (isLinkable) {
              columnOptions?.onRowLinkClick?.(row);
            } else if (isBreakdown) {
              columnOptions?.onBreakdownClick?.(row);
            }
          }
        }}
      >
        {row?.rowMetadata?.platformId && (
          <div className="inline-block">
            <AdIcon sizeInEM={1} platform={row?.rowMetadata.platformId} />
          </div>
        )}
        <span className={clsx(isLinkable && "hover-underline text-primary")}>
          {row?.display.Name}
        </span>
      </div>
      {row?.rowMetadata?.extraDetails?.map(({ name, value }: any) => (
        <small
          className="text-xs font-medium text-[#44515C] block -mt-0.5"
          key={jsonHash({ name, value })}
        >
          {`${name}:  ${value}`}
        </small>
      ))}
    </>
  );
};

export const DimensionTypeProvider = (props: any) => (
  <DataTypeProvider formatterComponent={DimensionDataFormatter} {...props} />
);
